"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Spotlight = /*#__PURE__*/function (_Component) {
  _inherits(Spotlight, _Component);

  var _super = _createSuper(Spotlight);

  function Spotlight(props) {
    var _this;

    _classCallCheck(this, Spotlight);

    _this = _super.call(this, props);
    _this.state = {
      visible: false,
      target: null,
      rectangles: {
        left: {
          width: null,
          height: null,
          top: null,
          left: null
        },
        top: {
          width: "100%",
          height: null,
          top: null,
          left: null
        },
        right: {
          width: null,
          height: null,
          top: null,
          left: null
        },
        bottom: {
          width: "100%",
          height: null,
          top: null,
          left: null
        }
      },
      opacity: 0
    };
    _this.onScroll = _this.onScroll.bind(_assertThisInitialized(_this));
    _this.getPadding = _this.getPadding.bind(_assertThisInitialized(_this));
    _this.getContext = _this.getContext.bind(_assertThisInitialized(_this));
    _this.fadeOutTimeout = null;
    return _this;
  }

  _createClass(Spotlight, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.getContext().removeEventListener('scroll', this.onScroll);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      if (this.state.visible === true && this.state.target !== null && (prevState.visible === false || prevState.opacity < this.props.maxOpacity)) {
        clearTimeout(this.fadeOutTimeout);
        setTimeout(function () {
          _this2.setState({
            opacity: _this2.props.maxOpacity
          });
        }, 10);
      } else if (this.state.opacity === 0 && prevState.opacity > 0 && this.state.visible === true) {
        this.fadeOutTimeout = setTimeout(function () {
          _this2.setState({
            visible: false
          });
        }, this.props.fadeTime);
      }
    }
  }, {
    key: "show",
    value: function show(target) {
      this.setState({
        visible: true,
        target: target
      });
      this.getContext().addEventListener('scroll', this.onScroll);
      this.setRectanglesSize(target);
    }
  }, {
    key: "onScroll",
    value: function onScroll() {
      if (this.state.target !== null) {
        this.setRectanglesSize(this.state.target);
      }
    }
  }, {
    key: "setRectanglesSize",
    value: function setRectanglesSize(target) {
      var boundingClientRect = target.getBoundingClientRect();
      var windowWidth = document.documentElement.clientWidth || document.body.clientWidth;
      var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      var leftWidth = boundingClientRect.left - this.getPadding('horizontal');
      var left = {
        width: "".concat(leftWidth > 0 ? leftWidth : 0, "px"),
        height: "".concat(boundingClientRect.height + this.getPadding('vertical') * 2, "px"),
        top: "".concat(boundingClientRect.top - this.getPadding('vertical'), "px"),
        left: "0px"
      };
      var topHeight = boundingClientRect.top - this.getPadding('vertical');
      var top = {
        width: "100%",
        height: "".concat(topHeight > 0 ? topHeight : 0, "px"),
        top: "0px",
        left: "0px"
      };
      var rightWidth = windowWidth - boundingClientRect.right - this.getPadding('horizontal');
      var right = {
        width: "".concat(rightWidth, "px"),
        height: "".concat(boundingClientRect.height + this.getPadding('horizontal') * 2, "px"),
        top: "".concat(boundingClientRect.top - this.getPadding('vertical'), "px"),
        right: "0px"
      };
      var bottomHeight = windowHeight - boundingClientRect.bottom - this.getPadding('vertical');
      var bottom = {
        width: "100%",
        height: "".concat(bottomHeight > 0 ? bottomHeight : 0, "px"),
        bottom: "0px",
        left: "0px"
      };
      this.setState({
        rectangles: {
          left: left,
          top: top,
          right: right,
          bottom: bottom
        }
      });
    }
  }, {
    key: "hide",
    value: function hide() {
      this.setState({
        opacity: 0,
        target: null
      });
      this.getContext().removeEventListener('scroll', this.onScroll);
    }
  }, {
    key: "getContext",
    value: function getContext() {
      var context = window;

      if (this.props.context) {
        if (this.props.context.indexOf('.') === 0) {
          context = document.getElementsByClassName(this.props.context.substr(1))[0];
        } else if (this.props.context.indexOf('#') === 0) {
          context = document.getElementById(this.props.context.substr(1));
        } else {
          context = window;
        }
      }

      if (!context) {
        console.warn("The context set on the spotlight wasn't found. Defaulted to window");
        context = window;
      }

      return context;
    }
  }, {
    key: "getBasicStyles",
    value: function getBasicStyles() {
      return {
        position: "fixed",
        zIndex: "9998",
        backgroundColor: this.props.backgroundColor,
        transition: this.props.fade ? "opacity ".concat(this.props.fadeTime, "ms") : null,
        opacity: "".concat(this.state.opacity)
      };
    }
  }, {
    key: "getPadding",
    value: function getPadding(position) {
      if (_typeof(this.props.padding) === 'object') {
        if (position === "horizontal") {
          return this.props.padding[1];
        } else {
          return this.props.padding[0];
        }
      }

      return this.props.padding;
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.visible === true) {
        return [/*#__PURE__*/_react["default"].createElement("div", {
          key: "spotlightLeft",
          style: Object.assign(this.getBasicStyles(), this.state.rectangles.left)
        }), /*#__PURE__*/_react["default"].createElement("div", {
          key: "spotlightTop",
          style: Object.assign(this.getBasicStyles(), this.state.rectangles.top)
        }), /*#__PURE__*/_react["default"].createElement("div", {
          key: "spotlightRight",
          style: Object.assign(this.getBasicStyles(), this.state.rectangles.right)
        }), /*#__PURE__*/_react["default"].createElement("div", {
          key: "spotlightBottom",
          style: Object.assign(this.getBasicStyles(), this.state.rectangles.bottom)
        })];
      } else {
        return null;
      }
    }
  }]);

  return Spotlight;
}(_react.Component);

Spotlight.propTypes = {
  backgroundColor: _propTypes["default"].string,
  maxOpacity: _propTypes["default"].number,
  fade: _propTypes["default"].bool,
  fadeTime: _propTypes["default"].number,
  padding: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].arrayOf(_propTypes["default"].number)]),
  context: _propTypes["default"].string
};
Spotlight.defaultProps = {
  backgroundColor: "#000",
  maxOpacity: 0.8,
  fade: true,
  fadeTime: 600,
  padding: 6
};
var _default = Spotlight;
exports["default"] = _default;